import { useCallback, useContext, useMemo } from 'react';

import { MainContext } from '@ezbobdev/ui-framework';

import { useUtils } from '../../utils/useUtils';

export const useCurrency = (props, widgetName) => {
  const { children } = props;
  const { actions } = useContext(MainContext);
  const { getConfig } = useUtils(props, widgetName);
  const { currency, currencySign, locale, useCustomCurrencyFormat } = actions.settings.getUserConfigProp('locals');
  const { minimumFractionDigits, maximumFractionDigits, numeralDecimalMark } = getConfig('formattingOptions', {});

  const formatCurrency = useCallback(
    (
      number,
      {
        style = 'currency',
        currency = '',
        currencyDisplay = 'narrowSymbol',
        minimumFractionDigits = 2,
        maximumFractionDigits = 2,
      },
    ) => {
      const isNumber = number !== undefined && number !== null && !isNaN(Number(number));
      if (!isNumber) return number;

      const formatterOptions = {
        style,
        currency,
        currencyDisplay,
        minimumFractionDigits,
        maximumFractionDigits,
      };

      const formatter = new Intl.NumberFormat(locale, formatterOptions);
      let formattedParts = formatter.formatToParts(number);
      let formattedNumber = formatter.format(number);

      if (numeralDecimalMark === '') {
        formattedParts = formattedParts.filter((part) => part.type !== 'group');
        const formattedValues = formattedParts.map((part) => part.value);
        formattedNumber = formattedValues.join('');
      }

      if (useCustomCurrencyFormat) {
        const formattedValues = formattedParts.map((part) => {
          if (part.type === 'currency') {
            part.value = currencySign;
          }
          return part.value;
        });
        formattedNumber = formattedValues.join('');
      }

      return formattedNumber;
    },
    [currency, currencySign, locale, minimumFractionDigits, maximumFractionDigits, useCustomCurrencyFormat],
  );

  const formattedValue = useMemo(
    () => formatCurrency(children, { currency, minimumFractionDigits, maximumFractionDigits }),
    [children, currency, minimumFractionDigits, maximumFractionDigits],
  );

  return { formattedValue };
};
